/*
 * @Author: luting
 * @Date: 2022-05-05 19:53:50
 * @lastEditors: luting
 * @LastEditTime: 2023-07-26 10:28:40
 */
import React, { useState, useMemo, useEffect, createRef } from 'react';
import { FormComponentProps } from 'sup-ui/lib/form';
import { message } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from './messages';

import { getRecipientApi, updateRecipientApi, delRecipientApi, mailsendTestApi } from 'root/services/notice';
import { INoticeType, IRecipientType } from './types';

import SupTable from 'sup-rc-table';
import CommonModal from 'root/components/CommonModal';
import PersonForm from './PersonForm';

import styles from './index.less';
const { confirm } = CommonModal;
type Ref = FormComponentProps;

const Person = () => {
  const intl = useIntl();
  const personFormRef = createRef<Ref>();
  const [selectKeys, setSelectKeys] = useState<string[]>([]);
  const [visible, setVisible] = useState({
    show: false,
    status: 'add',
  });
  const [dataSource, setDataSource] = useState<INoticeType[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });
  const [record, setRecord] = useState<IRecipientType | null>(null);

  const columns = useMemo(() => {
    return [
      {
        title: intl.formatMessage(messages.recipient),
        dataIndex: 'alertMailName',
      },
      {
        title: intl.formatMessage(messages.email),
        dataIndex: 'alertMailSend',
        width: 400,
      },
      {
        title: intl.formatMessage(messages.operate),
        dataIndex: 'operate',
        align: 'center',
        render: (text: string, record: INoticeType) => {
          const id: string = record.id as string;
          return (
            <div className={styles.operateBtn}>
              <span onClick={() => editEvent(record)}>{intl.formatMessage(messages.update)}</span>
              <span onClick={() => deleteEvent(id)}>{intl.formatMessage(messages.delete)}</span>
            </div>
          );
        },
      },
    ];
  }, []);

  const btnColumns = useMemo(() => {
    return [
      {
        key: 'add',
        content: intl.formatMessage(messages.add),
        callback: () => {
          setVisible({
            show: true,
            status: 'add',
          });
          setSelectKeys([]);
        },
      },
      {
        key: 'sendTestEmal',
        content: intl.formatMessage(messages.sendTestEmal),
        disabled: !selectKeys.length,
        className: styles.sendTestEmal,
        callback: () => {
          sendTestEmal();
        },
      },
      {
        key: 'delete',
        disabled: !selectKeys.length,
        callback: () => {
          deleteEvent();
        },
      },
    ];
  }, [selectKeys]);

  useEffect(() => {
    getRecipientList({ page: 1, size: 20 });
  }, []);

  // 获取数据列表
  const getRecipientList = (params: { page: number; size: number }) => {
    getRecipientApi(params).then((res) => {
      const {
        data: { data, count, page, size },
      } = res;
      setDataSource(data);
      setPagination({ pageSize: size, total: count, current: page });
    });
  };

  // 点击编辑将单条数据保存,并打开模态框
  const editEvent = (record: INoticeType) => {
    setRecord({
      name: record.alertMailName || '',
      address: record.alertMailSend || '',
      id: record.id,
    });
    setVisible({
      show: true,
      status: 'edit',
    });
  };

  // 删除时 弹出二次确认弹窗
  const deleteEvent = (id?: string) => {
    CommonModal.confirm({
      onOk: () => deleteData(id),
      okText: intl.formatMessage(messages.ok),
      cancelText: intl.formatMessage(messages.cancel),
      content: intl.formatMessage(messages.deleteTip),
    });
  };

  // 点击翻页(目前只有翻页)
  const handleSearch = (searchParams: any, type: string) => {
    const params: any = {
      pageSize: searchParams.pagination.pageSize,
      page: searchParams.pagination.current,
      size: searchParams.pagination.pageSize,
    };
    if (type === 'pagination' && searchParams.pageSize !== pagination.pageSize) {
      params.current = 1;
    }
    setSelectKeys([]);
    setPagination({ ...searchParams.pagination });
    getRecipientList({ page: searchParams.pagination.current, size: searchParams.pagination.pageSize });
  };

  // 选择列表项
  const handleChangeSelectItem = (keys: string[]) => {
    setSelectKeys(keys);
  };

  const handleOk = () => {
    personFormRef?.current?.form.validateFields((err: any, values: any) => {
      if (err) return;
      const params = {
        ...values,
        id: record?.id ? record.id : undefined,
      };
      updateRecipientApi(params).then(() => {
        personFormRef?.current?.form.resetFields();
        getRecipientList({ page: 1, size: 20 });
        setVisible({
          show: false,
          status: 'add',
        });
      });
    });
  };

  // 调删除接口
  const deleteData = (id?: string) => {
    const params = id ? [id] : selectKeys;
    delRecipientApi(params).then(() => {
      getRecipientList({ page: 1, size: 20 });
      setSelectKeys([]);
    });
  };
  // 发送测试邮件
  const sendTestEmal = (id?: string) => {
    confirm({
      title: intl.formatMessage(messages.sendTestEmalConfirm),
      onOk: () => {
        return new Promise((resolve, reject) => {
          const params = id ? [id] : selectKeys;
          mailsendTestApi(params)
            .then((res: any) => {
              let str = '';
              dataSource.forEach((item: any) => {
                if (params.includes(item.id)) {
                  str += `${item.alertMailSend}、`;
                }
              });
              str = str.substring(0, str.length - 1);
              message.success(intl.formatMessage(messages.sendSuccessTip, { name: str }));
              setSelectKeys([]);
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
    });
  };

  const CancelEvent = () => {
    setVisible({
      show: false,
      status: 'add',
    });
    setRecord({
      name: '',
      address: '',
      id: '',
    });
  };

  return (
    <div className={`${styles.warnContainer} ${styles.personWrap}`}>
      <SupTable
        showSearchIcon={false}
        showColumnsFilter={false}
        columns={columns}
        btnColumns={btnColumns}
        dataSource={dataSource}
        pagination={pagination}
        onSearch={handleSearch}
        className={styles.table}
        showSelection
        selectedRowKeys={selectKeys}
        onSelectItem={handleChangeSelectItem}
        rowKey="id"
      />

      <CommonModal
        title={`${intl.formatMessage(visible.status !== 'add' ? messages.update : messages.add)}${intl.formatMessage(
          messages.recipient,
        )}`}
        visible={visible.show}
        height="auto"
        onCancel={CancelEvent}
        onOk={handleOk}
        destroyOnClose
      >
        <PersonForm record={record} wrappedComponentRef={personFormRef} />
      </CommonModal>
    </div>
  );
};

export default Person;
